/*Global*/
import logo from '../assets/Logo/Logo.png';

/*Home*/
import home1 from '../assets/Home/Home-1.jpg';
import home2 from '../assets/Home/Home-2.jpg';
import home3 from '../assets/Home/Home-3.jpg';

/*Partners*/
import partner1 from '../assets/Partners/Partner-1.png';
import partner2 from '../assets/Partners/Partner-2.png';
import partner3 from '../assets/Partners/Partner-3.png';
import partner4 from '../assets/Partners/Partner-4.png';
import partner5 from '../assets/Partners/Partner-5.png';
import partner6 from '../assets/Partners/Partner-6.png';
import partner7 from '../assets/Partners/Partner-7.png';
import partner8 from '../assets/Partners/Partner-8.png';

/*About*/ 
import about1 from '../assets/About/About-1.jpg';
import about2 from '../assets/About/About-2.jpg';
import about3 from '../assets/About/About-3.jpg';


/*Process*/ 
import step1 from '../assets/Process/Process-1.jpg';
import step2 from '../assets/Process/Process-2.jpg';
import step3 from '../assets/Process/Process-3.jpg';


/*Pricing*/ 
import plan1 from '../assets/Pricing/Plan-1.jpg';
import plan2 from '../assets/Pricing/Plan-2.jpg';
import plan3 from '../assets/Pricing/Plan-3.jpg';


/*Team*/
import team1 from '../assets/Team/Team-1.jpg';
import team2 from '../assets/Team/Team-2.jpg';
import team3 from '../assets/Team/Team-3.jpg';
import team4 from '../assets/Team/Team-4.jpg';


/*Testimonials*/
import testimonial1 from '../assets/Testimonials/Pic-1.jpg';
import testimonial2 from '../assets/Testimonials/Pic-2.jpg';
import testimonial3 from '../assets/Testimonials/Pic-3.jpg';
import testimonial4 from '../assets/Testimonials/Pic-4.jpg';


/*FAQs*/
import FAQs from '../assets/FAQs/FAQs.jpg';


/*Gallery*/
import gallery1 from '../assets/Gallery/Gallery-1.jpg';
import gallery2 from '../assets/Gallery/Gallery-2.jpg';
import gallery3 from '../assets/Gallery/Gallery-3.jpg';
import gallery4 from '../assets/Gallery/Gallery-4.jpg';
import gallery5 from '../assets/Gallery/Gallery-5.jpg';
import gallery6 from '../assets/Gallery/Gallery-6.jpg';
import gallery7 from '../assets/Gallery/Gallery-7.jpg';
import gallery8 from '../assets/Gallery/Gallery-8.jpg';


/*Careers*/
import careerIntro from '../assets/Career/Intro/Intro.jpg';
import position1 from '../assets/Career/Positions/Position-1.jpg';
import position2 from '../assets/Career/Positions/Position-2.jpg';
import position3 from '../assets/Career/Positions/Position-3.jpg';
import position4 from '../assets/Career/Positions/Position-4.jpg';
import position5 from '../assets/Career/Positions/Position-5.jpg';
import position6 from '../assets/Career/Positions/Position-6.jpg';


/*Portfolio*/
import portfolio1 from '../assets/Portfolio/Portfolio/Portfolio-1.jpg';
import portfolio1Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio1Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio1Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio1Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio1Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio1Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio2 from '../assets/Portfolio/Portfolio/Portfolio-2.jpg';
import portfolio2Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio2Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio2Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio2Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio2Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio2Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio3 from '../assets/Portfolio/Portfolio/Portfolio-3.jpg';
import portfolio3Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio3Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio3Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio3Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio3Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio3Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio4 from '../assets/Portfolio/Portfolio/Portfolio-4.jpg';
import portfolio4Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio4Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio4Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio4Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio4Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio4Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio5 from '../assets/Portfolio/Portfolio/Portfolio-5.jpg';
import portfolio5Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio5Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio5Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio5Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio5Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio5Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio6 from '../assets/Portfolio/Portfolio/Portfolio-6.jpg';
import portfolio6Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio6Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio6Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio6Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio6Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio6Gallery6 from '../assets/Portfolio/Gallery/6.jpg';


/*Venues*/
import venue1 from '../assets/Venue/Venues/Venue-1.jpg';
import venue1Gallery1 from '../assets/Venue/Gallery/1.jpg';
import venue1Gallery2 from '../assets/Venue/Gallery/2.jpg';
import venue1Gallery3 from '../assets/Venue/Gallery/3.jpg';
import venue1Gallery4 from '../assets/Venue/Gallery/4.jpg';
import venue1Gallery5 from '../assets/Venue/Gallery/5.jpg';
import venue1Gallery6 from '../assets/Venue/Gallery/6.jpg';

import venue2 from '../assets/Venue/Venues/Venue-2.jpg';
import venue2Gallery1 from '../assets/Venue/Gallery/1.jpg';
import venue2Gallery2 from '../assets/Venue/Gallery/2.jpg';
import venue2Gallery3 from '../assets/Venue/Gallery/3.jpg';
import venue2Gallery4 from '../assets/Venue/Gallery/4.jpg';
import venue2Gallery5 from '../assets/Venue/Gallery/5.jpg';
import venue2Gallery6 from '../assets/Venue/Gallery/6.jpg';

import venue3 from '../assets/Venue/Venues/Venue-3.jpg';
import venue3Gallery1 from '../assets/Venue/Gallery/1.jpg';
import venue3Gallery2 from '../assets/Venue/Gallery/2.jpg';
import venue3Gallery3 from '../assets/Venue/Gallery/3.jpg';
import venue3Gallery4 from '../assets/Venue/Gallery/4.jpg';
import venue3Gallery5 from '../assets/Venue/Gallery/5.jpg';
import venue3Gallery6 from '../assets/Venue/Gallery/6.jpg';

import venue4 from '../assets/Venue/Venues/Venue-4.jpg';
import venue4Gallery1 from '../assets/Venue/Gallery/1.jpg';
import venue4Gallery2 from '../assets/Venue/Gallery/2.jpg';
import venue4Gallery3 from '../assets/Venue/Gallery/3.jpg';
import venue4Gallery4 from '../assets/Venue/Gallery/4.jpg';
import venue4Gallery5 from '../assets/Venue/Gallery/5.jpg';
import venue4Gallery6 from '../assets/Venue/Gallery/6.jpg';

import venue5 from '../assets/Venue/Venues/Venue-5.jpg';
import venue5Gallery1 from '../assets/Venue/Gallery/1.jpg';
import venue5Gallery2 from '../assets/Venue/Gallery/2.jpg';
import venue5Gallery3 from '../assets/Venue/Gallery/3.jpg';
import venue5Gallery4 from '../assets/Venue/Gallery/4.jpg';
import venue5Gallery5 from '../assets/Venue/Gallery/5.jpg';
import venue5Gallery6 from '../assets/Venue/Gallery/6.jpg';

import venue6 from '../assets/Venue/Venues/Venue-6.jpg';
import venue6Gallery1 from '../assets/Venue/Gallery/1.jpg';
import venue6Gallery2 from '../assets/Venue/Gallery/2.jpg';
import venue6Gallery3 from '../assets/Venue/Gallery/3.jpg';
import venue6Gallery4 from '../assets/Venue/Gallery/4.jpg';
import venue6Gallery5 from '../assets/Venue/Gallery/5.jpg';
import venue6Gallery6 from '../assets/Venue/Gallery/6.jpg';


/*Menu*/
import starter1 from '../assets/Menu/Starters/Starter-1.jpg';
import starter2 from '../assets/Menu/Starters/Starter-2.jpg';
import starter3 from '../assets/Menu/Starters/Starter-3.jpg';
import starter4 from '../assets/Menu/Starters/Starter-4.jpg';
import starter5 from '../assets/Menu/Starters/Starter-5.jpg';
import starter6 from '../assets/Menu/Starters/Starter-6.jpg';
import starter7 from '../assets/Menu/Starters/Starter-7.jpg';
import starter8 from '../assets/Menu/Starters/Starter-8.jpg';

import salad1 from '../assets/Menu/Salads/Salad-1.jpg';
import salad2 from '../assets/Menu/Salads/Salad-2.jpg';
import salad3 from '../assets/Menu/Salads/Salad-3.jpg';
import salad4 from '../assets/Menu/Salads/Salad-4.jpg';
import salad5 from '../assets/Menu/Salads/Salad-5.jpg';
import salad6 from '../assets/Menu/Salads/Salad-6.jpg';
import salad7 from '../assets/Menu/Salads/Salad-7.jpg';
import salad8 from '../assets/Menu/Salads/Salad-8.jpg';

import mainCourse1 from '../assets/Menu/Main_Courses/Main-1.jpg';
import mainCourse2 from '../assets/Menu/Main_Courses/Main-2.jpg';
import mainCourse3 from '../assets/Menu/Main_Courses/Main-3.jpg';
import mainCourse4 from '../assets/Menu/Main_Courses/Main-4.jpg';
import mainCourse5 from '../assets/Menu/Main_Courses/Main-5.jpg';
import mainCourse6 from '../assets/Menu/Main_Courses/Main-6.jpg';
import mainCourse7 from '../assets/Menu/Main_Courses/Main-7.jpg';
import mainCourse8 from '../assets/Menu/Main_Courses/Main-8.jpg';

import dessert1 from '../assets/Menu/Desserts/Dessert-1.jpg';
import dessert2 from '../assets/Menu/Desserts/Dessert-2.jpg';
import dessert3 from '../assets/Menu/Desserts/Dessert-3.jpg';
import dessert4 from '../assets/Menu/Desserts/Dessert-4.jpg';
import dessert5 from '../assets/Menu/Desserts/Dessert-5.jpg';
import dessert6 from '../assets/Menu/Desserts/Dessert-6.jpg';
import dessert7 from '../assets/Menu/Desserts/Dessert-7.jpg';
import dessert8 from '../assets/Menu/Desserts/Dessert-8.jpg';

import beverage1 from '../assets/Menu/Beverages/Beverage-1.jpg';
import beverage2 from '../assets/Menu/Beverages/Beverage-2.jpg';
import beverage3 from '../assets/Menu/Beverages/Beverage-3.jpg';
import beverage4 from '../assets/Menu/Beverages/Beverage-4.jpg';
import beverage5 from '../assets/Menu/Beverages/Beverage-5.jpg';
import beverage6 from '../assets/Menu/Beverages/Beverage-6.jpg';
import beverage7 from '../assets/Menu/Beverages/Beverage-7.jpg';
import beverage8 from '../assets/Menu/Beverages/Beverage-8.jpg';


/*Event Menu*/
import canapés1 from '../assets/Menu/Starters/Starter-1.jpg';
import canapés2 from '../assets/Menu/Starters/Starter-2.jpg';
import canapés3 from '../assets/Menu/Starters/Starter-3.jpg';
import canapés4 from '../assets/Menu/Starters/Starter-4.jpg';
import canapés5 from '../assets/Menu/Starters/Starter-5.jpg';
import canapés6 from '../assets/Menu/Starters/Starter-6.jpg';
import canapés7 from '../assets/Menu/Starters/Starter-7.jpg';
import canapés8 from '../assets/Menu/Starters/Starter-8.jpg';

import buffet1 from '../assets/Menu/Salads/Salad-1.jpg';
import buffet2 from '../assets/Menu/Salads/Salad-2.jpg';
import buffet3 from '../assets/Menu/Salads/Salad-3.jpg';
import buffet4 from '../assets/Menu/Salads/Salad-4.jpg';
import buffet5 from '../assets/Menu/Salads/Salad-5.jpg';
import buffet6 from '../assets/Menu/Salads/Salad-6.jpg';
import buffet7 from '../assets/Menu/Salads/Salad-7.jpg';
import buffet8 from '../assets/Menu/Salads/Salad-8.jpg';

import plated1 from '../assets/Menu/Main_Courses/Main-1.jpg';
import plated2 from '../assets/Menu/Main_Courses/Main-2.jpg';
import plated3 from '../assets/Menu/Main_Courses/Main-3.jpg';
import plated4 from '../assets/Menu/Main_Courses/Main-4.jpg';
import plated5 from '../assets/Menu/Main_Courses/Main-5.jpg';
import plated6 from '../assets/Menu/Main_Courses/Main-6.jpg';
import plated7 from '../assets/Menu/Main_Courses/Main-7.jpg';
import plated8 from '../assets/Menu/Main_Courses/Main-8.jpg';

import BBQ1 from '../assets/Menu/Desserts/Dessert-1.jpg';
import BBQ2 from '../assets/Menu/Desserts/Dessert-2.jpg';
import BBQ3 from '../assets/Menu/Desserts/Dessert-3.jpg';
import BBQ4 from '../assets/Menu/Desserts/Dessert-4.jpg';
import BBQ5 from '../assets/Menu/Desserts/Dessert-5.jpg';
import BBQ6 from '../assets/Menu/Desserts/Dessert-6.jpg';
import BBQ7 from '../assets/Menu/Desserts/Dessert-7.jpg';
import BBQ8 from '../assets/Menu/Desserts/Dessert-8.jpg';

import cocktail1 from '../assets/Menu/Beverages/Beverage-1.jpg';
import cocktail2 from '../assets/Menu/Beverages/Beverage-2.jpg';
import cocktail3 from '../assets/Menu/Beverages/Beverage-3.jpg';
import cocktail4 from '../assets/Menu/Beverages/Beverage-4.jpg';
import cocktail5 from '../assets/Menu/Beverages/Beverage-5.jpg';
import cocktail6 from '../assets/Menu/Beverages/Beverage-6.jpg';
import cocktail7 from '../assets/Menu/Beverages/Beverage-7.jpg';
import cocktail8 from '../assets/Menu/Beverages/Beverage-8.jpg';


/*service*/
import service1 from '../assets/Service/Services/Service-1.jpg';
import service1Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service1Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service2 from '../assets/Service/Services/Service-2.jpg';
import service2Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service2Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service3 from '../assets/Service/Services/Service-3.jpg';
import service3Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service3Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service4 from '../assets/Service/Services/Service-4.jpg';
import service4Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service4Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service5 from '../assets/Service/Services/Service-5.jpg';
import service5Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service5Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service6 from '../assets/Service/Services/Service-6.jpg';
import service6Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service6Gallery2 from '../assets/Service/Service-Gallery/2.jpg';


/*Events*/
import event1 from '../assets/Event/Events/Event-1.jpg';
import event1Gallery1 from '../assets/Event/Gallery/1.jpg';
import event1Gallery2 from '../assets/Event/Gallery/2.jpg';
import event1Gallery3 from '../assets/Event/Gallery/3.jpg';
import event1Gallery4 from '../assets/Event/Gallery/4.jpg';
import event1Gallery5 from '../assets/Event/Gallery/5.jpg';
import event1Gallery6 from '../assets/Event/Gallery/6.jpg';
import event1Gallery7 from '../assets/Event/Gallery/7.jpg';
import event1Gallery8 from '../assets/Event/Gallery/8.jpg';
import event1Gallery9 from '../assets/Event/Gallery/9.jpg';

import event2 from '../assets/Event/Events/Event-2.jpg';
import event2Gallery1 from '../assets/Event/Gallery/1.jpg';
import event2Gallery2 from '../assets/Event/Gallery/2.jpg';
import event2Gallery3 from '../assets/Event/Gallery/3.jpg';
import event2Gallery4 from '../assets/Event/Gallery/4.jpg';
import event2Gallery5 from '../assets/Event/Gallery/5.jpg';
import event2Gallery6 from '../assets/Event/Gallery/6.jpg';
import event2Gallery7 from '../assets/Event/Gallery/7.jpg';
import event2Gallery8 from '../assets/Event/Gallery/8.jpg';
import event2Gallery9 from '../assets/Event/Gallery/9.jpg';

import event3 from '../assets/Event/Events/Event-3.jpg';
import event3Gallery1 from '../assets/Event/Gallery/1.jpg';
import event3Gallery2 from '../assets/Event/Gallery/2.jpg';
import event3Gallery3 from '../assets/Event/Gallery/3.jpg';
import event3Gallery4 from '../assets/Event/Gallery/4.jpg';
import event3Gallery5 from '../assets/Event/Gallery/5.jpg';
import event3Gallery6 from '../assets/Event/Gallery/6.jpg';
import event3Gallery7 from '../assets/Event/Gallery/7.jpg';
import event3Gallery8 from '../assets/Event/Gallery/8.jpg';
import event3Gallery9 from '../assets/Event/Gallery/9.jpg';

import event4 from '../assets/Event/Events/Event-4.jpg';
import event4Gallery1 from '../assets/Event/Gallery/1.jpg';
import event4Gallery2 from '../assets/Event/Gallery/2.jpg';
import event4Gallery3 from '../assets/Event/Gallery/3.jpg';
import event4Gallery4 from '../assets/Event/Gallery/4.jpg';
import event4Gallery5 from '../assets/Event/Gallery/5.jpg';
import event4Gallery6 from '../assets/Event/Gallery/6.jpg';
import event4Gallery7 from '../assets/Event/Gallery/7.jpg';
import event4Gallery8 from '../assets/Event/Gallery/8.jpg';
import event4Gallery9 from '../assets/Event/Gallery/9.jpg';

import event5 from '../assets/Event/Events/Event-5.jpg';
import event5Gallery1 from '../assets/Event/Gallery/1.jpg';
import event5Gallery2 from '../assets/Event/Gallery/2.jpg';
import event5Gallery3 from '../assets/Event/Gallery/3.jpg';
import event5Gallery4 from '../assets/Event/Gallery/4.jpg';
import event5Gallery5 from '../assets/Event/Gallery/5.jpg';
import event5Gallery6 from '../assets/Event/Gallery/6.jpg';
import event5Gallery7 from '../assets/Event/Gallery/7.jpg';
import event5Gallery8 from '../assets/Event/Gallery/8.jpg';
import event5Gallery9 from '../assets/Event/Gallery/9.jpg';

import event6 from '../assets/Event/Events/Event-6.jpg';
import event6Gallery1 from '../assets/Event/Gallery/1.jpg';
import event6Gallery2 from '../assets/Event/Gallery/2.jpg';
import event6Gallery3 from '../assets/Event/Gallery/3.jpg';
import event6Gallery4 from '../assets/Event/Gallery/4.jpg';
import event6Gallery5 from '../assets/Event/Gallery/5.jpg';
import event6Gallery6 from '../assets/Event/Gallery/6.jpg';
import event6Gallery7 from '../assets/Event/Gallery/7.jpg';
import event6Gallery8 from '../assets/Event/Gallery/8.jpg';
import event6Gallery9 from '../assets/Event/Gallery/9.jpg';


/*Blogs*/
import blog1 from '../assets/Blog/Blogs/Blog-1.jpg';
import blog1Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog1Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog1Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog1Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog1Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog2 from '../assets/Blog/Blogs/Blog-2.jpg';
import blog2Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog2Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog2Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog2Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog2Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog3 from '../assets/Blog/Blogs/Blog-3.jpg';
import blog3Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog3Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog3Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog3Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog3Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog4 from '../assets/Blog/Blogs/Blog-4.jpg';
import blog4Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog4Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog4Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog4Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog4Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog5 from '../assets/Blog/Blogs/Blog-5.jpg';
import blog5Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog5Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog5Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog5Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog5Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog6 from '../assets/Blog/Blogs/Blog-6.jpg';
import blog6Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog6Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog6Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog6Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog6Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog7 from '../assets/Blog/Blogs/Blog-7.jpg';
import blog7Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog7Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog7Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog7Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog7Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog8 from '../assets/Blog/Blogs/Blog-8.jpg';
import blog8Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog8Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog8Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog8Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog8Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog9 from '../assets/Blog/Blogs/Blog-9.jpg';
import blog9Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog9Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog9Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog9Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog9Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog10 from '../assets/Blog/Blogs/Blog-10.jpg';
import blog10Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog10Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog10Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog10Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog10Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog11 from '../assets/Blog/Blogs/Blog-11.jpg';
import blog11Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog11Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog11Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog11Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog11Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog12 from '../assets/Blog/Blogs/Blog-12.jpg';
import blog12Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog12Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog12Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog12Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog12Comment3 from '../assets/Blog/Comments/Pic-3.jpg';


/*Shop*/
import product1Gallery1 from '../assets/Shop/Products/1.jpg';
import product1Gallery2 from '../assets/Shop/Products/2.jpg';
import product1Gallery3 from '../assets/Shop/Products/3.jpg';
import product1Gallery4 from '../assets/Shop/Products/4.jpg';
import product1Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product1Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product2Gallery1 from '../assets/Shop/Products/2.jpg';
import product2Gallery2 from '../assets/Shop/Products/3.jpg';
import product2Gallery3 from '../assets/Shop/Products/4.jpg';
import product2Gallery4 from '../assets/Shop/Products/5.jpg';
import product2Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product2Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product3Gallery1 from '../assets/Shop/Products/3.jpg';
import product3Gallery2 from '../assets/Shop/Products/4.jpg';
import product3Gallery3 from '../assets/Shop/Products/5.jpg';
import product3Gallery4 from '../assets/Shop/Products/6.jpg';
import product3Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product3Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product4Gallery1 from '../assets/Shop/Products/4.jpg';
import product4Gallery2 from '../assets/Shop/Products/5.jpg';
import product4Gallery3 from '../assets/Shop/Products/6.jpg';
import product4Gallery4 from '../assets/Shop/Products/7.jpg';
import product4Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product4Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product5Gallery1 from '../assets/Shop/Products/5.jpg';
import product5Gallery2 from '../assets/Shop/Products/6.jpg';
import product5Gallery3 from '../assets/Shop/Products/7.jpg';
import product5Gallery4 from '../assets/Shop/Products/8.jpg';
import product5Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product5Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product6Gallery1 from '../assets/Shop/Products/6.jpg';
import product6Gallery2 from '../assets/Shop/Products/7.jpg';
import product6Gallery3 from '../assets/Shop/Products/8.jpg';
import product6Gallery4 from '../assets/Shop/Products/9.jpg';
import product6Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product6Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product7Gallery1 from '../assets/Shop/Products/7.jpg';
import product7Gallery2 from '../assets/Shop/Products/8.jpg';
import product7Gallery3 from '../assets/Shop/Products/9.jpg';
import product7Gallery4 from '../assets/Shop/Products/10.jpg';
import product7Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product7Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product8Gallery1 from '../assets/Shop/Products/8.jpg';
import product8Gallery2 from '../assets/Shop/Products/9.jpg';
import product8Gallery3 from '../assets/Shop/Products/10.jpg';
import product8Gallery4 from '../assets/Shop/Products/11.jpg';
import product8Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product8Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product9Gallery1 from '../assets/Shop/Products/9.jpg';
import product9Gallery2 from '../assets/Shop/Products/10.jpg';
import product9Gallery3 from '../assets/Shop/Products/11.jpg';
import product9Gallery4 from '../assets/Shop/Products/12.jpg';
import product9Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product9Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product10Gallery1 from '../assets/Shop/Products/10.jpg';
import product10Gallery2 from '../assets/Shop/Products/11.jpg';
import product10Gallery3 from '../assets/Shop/Products/12.jpg';
import product10Gallery4 from '../assets/Shop/Products/13.jpg';
import product10Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product10Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product11Gallery1 from '../assets/Shop/Products/11.jpg';
import product11Gallery2 from '../assets/Shop/Products/12.jpg';
import product11Gallery3 from '../assets/Shop/Products/13.jpg';
import product11Gallery4 from '../assets/Shop/Products/14.jpg';
import product11Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product11Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product12Gallery1 from '../assets/Shop/Products/12.jpg';
import product12Gallery2 from '../assets/Shop/Products/13.jpg';
import product12Gallery3 from '../assets/Shop/Products/14.jpg';
import product12Gallery4 from '../assets/Shop/Products/15.jpg';
import product12Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product12Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product13Gallery1 from '../assets/Shop/Products/13.jpg';
import product13Gallery2 from '../assets/Shop/Products/14.jpg';
import product13Gallery3 from '../assets/Shop/Products/15.jpg';
import product13Gallery4 from '../assets/Shop/Products/1.jpg';
import product13Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product13Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product14Gallery1 from '../assets/Shop/Products/14.jpg';
import product14Gallery2 from '../assets/Shop/Products/15.jpg';
import product14Gallery3 from '../assets/Shop/Products/1.jpg';
import product14Gallery4 from '../assets/Shop/Products/2.jpg';
import product14Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product14Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product15Gallery1 from '../assets/Shop/Products/15.jpg';
import product15Gallery2 from '../assets/Shop/Products/1.jpg';
import product15Gallery3 from '../assets/Shop/Products/2.jpg';
import product15Gallery4 from '../assets/Shop/Products/3.jpg';
import product15Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product15Review2 from '../assets/Shop/Reviews/Pic-2.jpg';



const images = {

    /*Global*/
    logo,

    /*Home*/
    home1,
    home2,
    home3,

    /*Partners*/
    partner1,
    partner2,
    partner3,
    partner4,
    partner5,
    partner6,
    partner7,
    partner8,

    /*About*/
    about1,
    about2,
    about3,

    /*Process*/
    step1,
    step2,
    step3,

    /*Pricing*/
    plan1,
    plan2,
    plan3,

    /*Team*/
    team1,
    team2,
    team3, 
    team4,

    /*Testimonials*/
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,

    /*FAQs*/ 
    FAQs,

    /*Gallery*/
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,

    /*Career Introduction*/
    careerIntro,

    /*Positions*/
    position1,
    position2,
    position3,
    position4,
    position5,
    position6,

    /*Venues*/
    venue1,
    venue1Gallery1,
    venue1Gallery2,
    venue1Gallery3,
    venue1Gallery4,
    venue1Gallery5,
    venue1Gallery6,

    venue2,
    venue2Gallery1,
    venue2Gallery2,
    venue2Gallery3,
    venue2Gallery4,
    venue2Gallery5,
    venue2Gallery6,

    venue3,
    venue3Gallery1,
    venue3Gallery2,
    venue3Gallery3,
    venue3Gallery4,
    venue3Gallery5,
    venue3Gallery6,

    venue4,
    venue4Gallery1,
    venue4Gallery2,
    venue4Gallery3,
    venue4Gallery4,
    venue4Gallery5,
    venue4Gallery6,

    venue5,
    venue5Gallery1,
    venue5Gallery2,
    venue5Gallery3,
    venue5Gallery4,
    venue5Gallery5,
    venue5Gallery6,

    venue6,
    venue6Gallery1,
    venue6Gallery2,
    venue6Gallery3,
    venue6Gallery4,
    venue6Gallery5,
    venue6Gallery6,

    /*Menu*/
    starter1,
    starter2,
    starter3,
    starter4,
    starter5,
    starter6,
    starter7,
    starter8,

    salad1,
    salad2,
    salad3,
    salad4,
    salad5,
    salad6,
    salad7,
    salad8,

    mainCourse1,
    mainCourse2,
    mainCourse3,
    mainCourse4,
    mainCourse5,
    mainCourse6,
    mainCourse7,
    mainCourse8,

    dessert1,
    dessert2,
    dessert3,
    dessert4,
    dessert5,
    dessert6,
    dessert7,
    dessert8,

    beverage1,
    beverage2,
    beverage3,
    beverage4,
    beverage5,
    beverage6,
    beverage7,
    beverage8,

    /*Event Menu*/
    canapés1,
    canapés2,
    canapés3,
    canapés4,
    canapés5,
    canapés6,
    canapés7,
    canapés8,

    buffet1,
    buffet2,
    buffet3,
    buffet4,
    buffet5,
    buffet6,
    buffet7,
    buffet8,

    plated1,
    plated2,
    plated3,
    plated4,
    plated5,
    plated6,
    plated7,
    plated8,

    BBQ1,
    BBQ2,
    BBQ3,
    BBQ4,
    BBQ5,
    BBQ6,
    BBQ7,
    BBQ8,

    cocktail1,
    cocktail2,
    cocktail3,
    cocktail4,
    cocktail5,
    cocktail6,
    cocktail7,
    cocktail8,

    /*Services*/
    service1,
    service1Gallery1,
    service1Gallery2,

    service2,
    service2Gallery1,
    service2Gallery2,

    service3,
    service3Gallery1,
    service3Gallery2,

    service4,
    service4Gallery1,
    service4Gallery2,

    service5,
    service5Gallery1,
    service5Gallery2,

    service6,
    service6Gallery1,
    service6Gallery2,

    /*Events*/
    event1,
    event1Gallery1,
    event1Gallery2,
    event1Gallery3,
    event1Gallery4,
    event1Gallery5,
    event1Gallery6,
    event1Gallery7,
    event1Gallery8,
    event1Gallery9,

    event2,
    event2Gallery1,
    event2Gallery2,
    event2Gallery3,
    event2Gallery4,
    event2Gallery5,
    event2Gallery6,
    event2Gallery7,
    event2Gallery8,
    event2Gallery9,

    event3,
    event3Gallery1,
    event3Gallery2,
    event3Gallery3,
    event3Gallery4,
    event3Gallery5,
    event3Gallery6,
    event3Gallery7,
    event3Gallery8,
    event3Gallery9,

    event4,
    event4Gallery1,
    event4Gallery2,
    event4Gallery3,
    event4Gallery4,
    event4Gallery5,
    event4Gallery6,
    event4Gallery7,
    event4Gallery8,
    event4Gallery9,

    event5,
    event5Gallery1,
    event5Gallery2,
    event5Gallery3,
    event5Gallery4,
    event5Gallery5,
    event5Gallery6,
    event5Gallery7,
    event5Gallery8,
    event5Gallery9,

    event6,
    event6Gallery1,
    event6Gallery2,
    event6Gallery3,
    event6Gallery4,
    event6Gallery5,
    event6Gallery6,
    event6Gallery7,
    event6Gallery8,
    event6Gallery9,

    /*Portfolios*/
    portfolio1,
    portfolio1Gallery1,
    portfolio1Gallery2,
    portfolio1Gallery3,
    portfolio1Gallery4,
    portfolio1Gallery5,
    portfolio1Gallery6,

    portfolio2,
    portfolio2Gallery1,
    portfolio2Gallery2,
    portfolio2Gallery3,
    portfolio2Gallery4,
    portfolio2Gallery5,
    portfolio2Gallery6,

    portfolio3,
    portfolio3Gallery1,
    portfolio3Gallery2,
    portfolio3Gallery3,
    portfolio3Gallery4,
    portfolio3Gallery5,
    portfolio3Gallery6,

    portfolio4,
    portfolio4Gallery1,
    portfolio4Gallery2,
    portfolio4Gallery3,
    portfolio4Gallery4,
    portfolio4Gallery5,
    portfolio4Gallery6,

    portfolio5,
    portfolio5Gallery1,
    portfolio5Gallery2,
    portfolio5Gallery3,
    portfolio5Gallery4,
    portfolio5Gallery5,
    portfolio5Gallery6,

    portfolio6,
    portfolio6Gallery1,
    portfolio6Gallery2,
    portfolio6Gallery3,
    portfolio6Gallery4,
    portfolio6Gallery5,
    portfolio6Gallery6,

    /*Blogs*/
    blog1,
    blog1Gallery1,
    blog1Gallery2,
    blog1Comment1,
    blog1Comment2,
    blog1Comment3,

    blog2,
    blog2Gallery1,
    blog2Gallery2,
    blog2Comment1,
    blog2Comment2,
    blog2Comment3,

    blog3,
    blog3Gallery1,
    blog3Gallery2,
    blog3Comment1,
    blog3Comment2,
    blog3Comment3,

    blog4,
    blog4Gallery1,
    blog4Gallery2,
    blog4Comment1,
    blog4Comment2,
    blog4Comment3,

    blog5,
    blog5Gallery1,
    blog5Gallery2,
    blog5Comment1,
    blog5Comment2,
    blog5Comment3,

    blog6,
    blog6Gallery1,
    blog6Gallery2,
    blog6Comment1,
    blog6Comment2,
    blog6Comment3,

    blog7,
    blog7Gallery1,
    blog7Gallery2,
    blog7Comment1,
    blog7Comment2,
    blog7Comment3,

    blog8,
    blog8Gallery1,
    blog8Gallery2,
    blog8Comment1,
    blog8Comment2,
    blog8Comment3,

    blog9,
    blog9Gallery1,
    blog9Gallery2,
    blog9Comment1,
    blog9Comment2,
    blog9Comment3,

    blog10,
    blog10Gallery1,
    blog10Gallery2,
    blog10Comment1,
    blog10Comment2,
    blog10Comment3,

    blog11,
    blog11Gallery1,
    blog11Gallery2,
    blog11Comment1,
    blog11Comment2,
    blog11Comment3,

    blog12,
    blog12Gallery1,
    blog12Gallery2,
    blog12Comment1,
    blog12Comment2,
    blog12Comment3,

    /*Shop*/
    product1Gallery1,
    product1Gallery2,
    product1Gallery3, 
    product1Gallery4,
    product1Review1,
    product1Review2,

    product2Gallery1,
    product2Gallery2,
    product2Gallery3,
    product2Gallery4,
    product2Review1,
    product2Review2,

    product3Gallery1,
    product3Gallery2,
    product3Gallery3,
    product3Gallery4,
    product3Review1,
    product3Review2,

    product4Gallery1,
    product4Gallery2,
    product4Gallery3,
    product4Gallery4,
    product4Review1,
    product4Review2,

    product5Gallery1,
    product5Gallery2,
    product5Gallery3,
    product5Gallery4,
    product5Review1,
    product5Review2,

    product6Gallery1,
    product6Gallery2,
    product6Gallery3,
    product6Gallery4,
    product6Review1,
    product6Review2,

    product7Gallery1,
    product7Gallery2,
    product7Gallery3,
    product7Gallery4,
    product7Review1,
    product7Review2,

    product8Gallery1,
    product8Gallery2,
    product8Gallery3,
    product8Gallery4,
    product8Review1,
    product8Review2,

    product9Gallery1,
    product9Gallery2,
    product9Gallery3,
    product9Gallery4,
    product9Review1,
    product9Review2,

    product10Gallery1,
    product10Gallery2,
    product10Gallery3,
    product10Gallery4,
    product10Review1,
    product10Review2,

    product11Gallery1,
    product11Gallery2,
    product11Gallery3,
    product11Gallery4,
    product11Review1,
    product11Review2,

    product12Gallery1,
    product12Gallery2,
    product12Gallery3,
    product12Gallery4,
    product12Review1,
    product12Review2,

    product13Gallery1,
    product13Gallery2,
    product13Gallery3,
    product13Gallery4,
    product13Review1,
    product13Review2,

    product14Gallery1,
    product14Gallery2,
    product14Gallery3,
    product14Gallery4,
    product14Review1,
    product14Review2,

    product15Gallery1,
    product15Gallery2,
    product15Gallery3,
    product15Gallery4,
    product15Review1,
    product15Review2,

};

export default images;